module.exports = __webpack_public_path__ + "static/img/sceneMenu.942e808b.png";